import React, { memo } from 'react';
import { Box, Button, Grid, Typography } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import AddIcon from '@mui/icons-material/Add';
import Main from 'components/Main/Main';
import useRemessasCriadasHook from './hooks/useRemessasCriadasHook';
import ChipsFiltrosAtivos from './componentes/ChipsFiltrosAtivos/ChipsFiltrosAtivos';
import TabelaResultados from './componentes/TabelaResultados/TabelaResultados';
import DrawerFiltros from './componentes/DrawerFiltros/DrawerFiltros';
import ModalNovaRemessa from './componentes/ModalNovaRemessa/ModalNovaRemessa';
import './RemessasCriadas.css';

const RemessasCriadas = ({ escopoAcesso, setEscopoAcesso }) => {
  const {
    filtrosAplicados,
    drawerAberto,
    modalAberto,
    resultados,
    carregando,
    totalRegistros,
    paginationModel,
    sortModel,
    abrirDrawer,
    fecharDrawer,
    abrirModal,
    fecharModal,
    aplicarFiltros,
    limparFiltros,
    recarregarListaAtual,
    handlePaginationModelChange,
    handleSortModelChange,
    obterChipsFiltros
  } = useRemessasCriadasHook();

  const chipsFiltros = obterChipsFiltros();
  const filtrosSelecionados = filtrosAplicados ?? {};

  return (
    <Main
      title="Remessas Criadas"
      className="remessas-criadas-main"
      escopoAcesso={escopoAcesso}
      setEscopoAcesso={setEscopoAcesso}
    >
      <Box className="remessas-criadas-container">
        {/* Cabeçalho */}
        <Box className="remessas-cabecalho">
          <Box className="remessas-cabecalho-esquerda">
            <Typography className="remessas-titulo">Remessas Criadas</Typography>
            <Typography className="remessas-subtitulo">
              Gerencie e acompanhe todas as remessas criadas
            </Typography>
          </Box>
          <Box className="remessas-acoes">
            <Button
              variant="outlined"
              startIcon={<FilterListIcon />}
              onClick={abrirDrawer}
              className="remessas-btn-filtros"
            >
              Filtros
            </Button>
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={abrirModal}
              className="remessas-btn-nova"
            >
              Nova Remessa
            </Button>
          </Box>
        </Box>

        {/* Chips de Filtros Ativos */}
        <ChipsFiltrosAtivos chips={chipsFiltros} />

        {/* Conteúdo Principal */}
        <Grid container>
          <Grid item xs={12}>
            <TabelaResultados
              resultados={resultados}
              carregando={carregando}
              totalRegistros={totalRegistros}
              paginationModel={paginationModel}
              sortModel={sortModel}
              onPaginationModelChange={handlePaginationModelChange}
              onSortModelChange={handleSortModelChange}
            />
          </Grid>
        </Grid>

        {/* Drawer de Filtros */}
        <DrawerFiltros
          aberto={drawerAberto}
          onFechar={fecharDrawer}
          onAplicarFiltros={aplicarFiltros}
          onLimparFiltros={limparFiltros}
          filtrosAplicados={filtrosSelecionados}
        />

        {/* Modal Nova Remessa */}
        <ModalNovaRemessa
          aberto={modalAberto}
          onFechar={fecharModal}
          abrirModal={abrirModal}
          onRemessaCriada={recarregarListaAtual}
        />
      </Box>
    </Main>
  );
};

export default memo(RemessasCriadas);
